import { toString3o7ifthqydp6e as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyCodesClass;
function KeyCodes() {
  if (KeyCodesClass === VOID) {
    class $ {
      cax() {
        return 'ArrowUp';
      }
      dax() {
        return 'ArrowDown';
      }
      eax(char) {
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        return 'Key' + toString(char).toUpperCase();
      }
      fax() {
        return 'Space';
      }
      gax() {
        return 'Enter';
      }
    }
    initMetadataForObject($, 'KeyCodes');
    KeyCodesClass = $;
  }
  return KeyCodesClass;
}
var KeyCodes_instance;
function KeyCodes_getInstance() {
  return KeyCodes_instance;
}
//region block: init
KeyCodes_instance = new (KeyCodes())();
//endregion
//region block: exports
export {
  KeyCodes_instance as KeyCodes_instancevfnkc2xsbiba,
};
//endregion

//# sourceMappingURL=KeyCode.commonHtml.mjs.map
